import React from 'react';

import { PageLayout } from 'src/components/common';
import { pageLayoutPaperSx } from 'src/constants/styles';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useVerifiers } from 'src/hooks/verifier';
import { prepareVerifiersFilter } from 'src/utils/verifiers';

import { prepareSearchFilterByCategories } from './utils';
import { VerifiersTableClearVerifyStaff } from './VerifiersTableClearVerifyStaff';

export const VerifiersPageWrapperClearVerifyAdmin: React.FC = () => {
  const searchQueryVariables = useSearchQueryVariables(prepareSearchFilterByCategories);
  const { filter, sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();
  const filterQueryVariables = prepareVerifiersFilter(filter);

  const { verifiersList, verifiersCount, verifiersLoading, refetch } = useVerifiers(
    {
      ...searchQueryVariables,
      ...filterQueryVariables,
    },
    sortQueryVariable,
    paginationQueryVariables,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <PageLayout titleContent="Verifiers" paperSx={pageLayoutPaperSx}>
      <VerifiersTableClearVerifyStaff
        verifiersList={verifiersList}
        verifiersCount={verifiersCount}
        onRefresh={refetchData}
        pagination={pagination}
        loading={verifiersLoading}
      />
    </PageLayout>
  );
};
